import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { Newspaper } from "lucide-react";

const sizeClass = (size) => {
  switch (size) {
    case "wide": return "sm:col-span-2";
    case "tall": return "sm:row-span-2";
    default: return "";
  }
};

export const Flyer = () => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/flyer").then(({ data }) => setSlots(data)).finally(() => setLoading(false));
  }, []);

  if (loading || slots.length === 0) return null;

  return (
    <section className="bg-[#0A0A0A] py-20 border-t border-white/5" data-testid="flyer-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-10">
          <div className="font-overline text-xs text-[#D4AF37] mb-3 flex items-center gap-2">
            <Newspaper className="w-4 h-4" /> — VOLANTONE
          </div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none">
            LE OFFERTE <span className="text-[#D4AF37]">DELLA SETTIMANA</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-rows-[280px] gap-4" data-testid="flyer-grid">
          {slots.map((s) => {
            const inner = (
              <div className={`group relative overflow-hidden border border-white/10 bg-[#141414] hover:border-[#D4AF37]/60 transition-colors h-full`}>
                {s.image_url ? (
                  <img
                    src={imgUrl(s.image_url, 800)}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500"
                    loading="lazy"
                  />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-[#141414] to-black" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

                {s.badge && (
                  <div className="absolute top-3 left-3 z-10 px-3 py-1.5 bg-[#D4AF37] text-black font-overline text-[10px]">
                    {s.badge}
                  </div>
                )}

                <div className="absolute bottom-0 left-0 right-0 p-6 z-10">
                  <h3 className="font-display font-black text-2xl leading-tight mb-1 group-hover:text-[#D4AF37] transition-colors">{s.title}</h3>
                  {s.subtitle && <p className="text-sm text-neutral-300 mb-3 line-clamp-2">{s.subtitle}</p>}
                  <div className="flex items-end justify-between gap-3">
                    <div className="flex items-baseline gap-2">
                      {typeof s.price === "number" && s.price > 0 && (
                        <span className="font-display font-black text-2xl text-[#D4AF37]">€{Number(s.price).toFixed(2)}</span>
                      )}
                      {typeof s.old_price === "number" && s.old_price > 0 && (
                        <span className="text-sm text-neutral-400 line-through">€{Number(s.old_price).toFixed(2)}</span>
                      )}
                    </div>
                    <span className="font-overline text-[10px] text-[#D4AF37]">{s.cta_label || "SCOPRI"} →</span>
                  </div>
                </div>
              </div>
            );
            const key = s.slot_id;
            const cls = `${sizeClass(s.size)}`;
            return s.cta_url && s.cta_url.startsWith("/") ? (
              <Link key={key} to={s.cta_url} className={cls} data-testid={`flyer-slot-${s.slot_id}`}>{inner}</Link>
            ) : (
              <a key={key} href={s.cta_url || "#"} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`flyer-slot-${s.slot_id}`}>{inner}</a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
